// The admin console's API contract (admin-openapi.yaml, served by the
// server's admin listener under /api/admin/v1). src/generated/admin-openapi.ts
// holds the types generated from it (`pnpm codegen`); requests go through
// openapi-fetch. The user app never imports this entry point.
import createClient, {} from "openapi-fetch";
/** Typed admin REST client; `baseUrl` is the admin origin plus `/api/admin/v1`. */
export function createAdminClient(options) {
    return createClient(options);
}
//# sourceMappingURL=admin.js.map